import defaultTheme from './defaultTheme';
import constants from '../../constants';
export default {
  ...defaultTheme,
  background: constants.Colors.DarkPurple,
  inputBackground: constants.Colors.newBackground,

  ///for account landing page
  container: constants.Colors.RegalBlue,
  balanceInfoContainer: '#040628',
  headerPocket: '#fff',
  headerTotalAmountTitle: '#fff',
  headerTotalAmountValue: '',
  headerCashBtn: '#f6324b',
  headerCashBtnLabel: '#fff',
  bottomVerifyContainer: '#040628',
  bottomVerifyMsgText: '#fff',
  bottomVerifyBtn: 'transparent',
  bottomVerifyBtnBorder: '#f6324b',
  bottomVerifyBtnText: '#fff',
  cashbackExpiryText: '#fff',

  //for wallet bottom component
  walletBottomContainer: '#040628',
  walletBottomTitle: '#fff',
  walletBottomValue: '#fff',

  //for wallet type
  walletTypeContainer: '#040628',
  walletTypeInfoIcon: '#fcfcfc',
  walletTypeTooltipBG: '#1f2a54',
  walletTypeTitle: '#fff',
  walletTypeBalance: '#fff',
  walletTypeVerticalBorder: '#1f2853',
  walletTypeBtn: '#f6324b',

  //for withdraw modal
  withdrawContainer: '#202953',
  withdrawBackBtn: '#fff',
  withdrawVerticalDivider: '#040628',
  withdrawTitle: constants.Colors.White,
  withdrawCurrentBalance: constants.Colors.White,
  withdrawCurrentBalanceValue: constants.Colors.White,
  withdrawInputBG: '#040628',
  withdrawInputText: constants.Colors.White,
  withdrawInputPlaceHolder: 'rgba(255, 255, 255, 0.45)',
  withdrawMinAmountLabel: constants.Colors.paleBlue,
  withdrawOptionBorder: '#434e85',
  withdrawOptionChecked: '#f6324b',
  withdrawOptionCheckBoxBorder: '#fff',
  withdrawPaytmTransferIcon: '#fff',
  withdrawOptionTitle: constants.Colors.White,
  withdrawButton: '#f6324b',
  withdrawButtonText: constants.Colors.White,
  withdrawError: '#f6324b',

  //for transaction history
  transactionHistoryContainer: constants.Colors.RegalBlue,
  transactionHistoryContainerWrapper: constants.Colors.newBackground,
  transactionHistoryTabBarDefault: '#040628',
  transactionHistoryTabBarActiveText: '#ffc400',
  transactionHistoryTabBarDefaultText: '#828494',
  transactionHistoryTabBarBorder: constants.Colors.RegalBlue,
  transactionHistoryTabBarActive: '#ffc600',

  // add cash modal
  addCashContainer: '#202953',
  addCashBackBtn: '#fff',
  addCashVerticalDivider: '#040628',
  addCashTitle: constants.Colors.White,
  addCashCurrentBalance: constants.Colors.White,
  addCashCurrentBalanceValue: constants.Colors.White,
  addCashBoxAmountWrapper: '#11173d',
  addCashBoxAmountWrapperBorder: '#11173d',
  addCashBoxAmountText: 'white',
  addCashPromoCodeLabel: '#fff',
  addCashAppliedPromoCode: '#11173d',
  addCashPromoCodeInputBG: '#040628',
  addCashPromoCodeInputText: constants.Colors.White,
  addCashPromoCodeInputPlaceHolder: 'rgba(255, 255, 255, 0.45)',
  addCashApplyButton: '#11173d',
  addCashApplyButtonText: constants.Colors.White,
  addCashPayUsing: constants.Colors.White,
  addCashRemoveIcon: constants.Colors.Dusk,
  addCashBtn: '#f6324b',
  addCashBtnText: '#fff',
  addCashPromoListItemBG: '#040628',
  addCashPromoListItemBorder: '#00d102',
  addCashPromoListItemTitle: '#fff',
  addCashPromoLoader: '#f6324b',

  //for transaction game item
  transactionContainer: '#0d0f34',
  transactionDateTime: '#fff',
  transactionContentText: '#fff',
  transactionExpandIconBG: '#0d0f34',
  transactionExpandIconBorder: '#707070',
  transactionExpandIcon: '#fff',
  transactionSeparator: constants.Colors.Dusk4,
  transactionDebit: '#ff4b4b',
  transactionCredit: '#00ff47',
  transactionPending: constants.Colors.OrangeYellow,
  transactionContentMainText: '#00d102',

  //for transaction earnings
  transactionTotalEarnings: '#fff',

  //for transfer money modal
  transferMoneyModalTitle: 'white',
  transferMoneyModalValue: 'white',
  transferMoneyRowBorder: constants.Colors.BlueGrey,
  transferMoneyYesBtn: constants.Colors.Green,
  transferMoneyNoBtn: constants.Colors.Pink,
  transferMoneyHeaderTitle: '#fff',
  transferMoneyAreYouSureText: constants.Colors.BlueGrey3,

  //for webview screen
  webviewBackground: constants.Colors.DarkPurple,

  //for payment success
  paymentSuccessTitle: '#fff',
  paymentSuccessGoBack: '#f6324b',
  paymentSuccessGoBackTitle: '#fff',

  //for payment failed
  paymentFailTitle: '#fff',
  paymentFailGoBack: '#f6324b',
  paymentFailGoBackTitle: '#fff',
  //transactionhistory

  transactionHistoryDefaultCol3Bg:
    'transparent radial-gradient(closest-side at 50% 50%, #314052 0%, #212C3A 100%) 0% 0% no-repeat padding-box',
  transactionHistoryDefaultCol3BoxShadow: '0px -2px 23px #020722B3',
  transactionHistoryDefaultColBg:
    'transparent radial-gradient(closest-side at 50% 50%, #171B20 0%, #101823 100%) 0% 0% no-repeat padding-box',
  transactionHistoryDefaultColBoxShadow: '0px 0px 17px #020722B3',
  transactionHistoryBorder: '#596779',
  transactionHistoryStatusContainerBg:
    'transparent radial-gradient(closest-side at 50% 50%, #171B20 0%, #101823 100%) 0% 0% no-repeat padding-box',
  transactionHistoryStatusContainerBoxShadow: '0px 0px 17px #020722B3',
  transactionHistoryStatusItemBg: '#FFC400 0% 0% no-repeat padding-box',
  transactionHistoryStatusItemTextColor: '#000',
  transactionHistoryActivebackdropFilter: 'blur(44px)',
  transactionHistoryActiveboxShadow: '0 10px 10px 0 rgba(0, 0, 0, 0.3)',
  transactionHistoryActivebackgroundImage: 'linear-gradient(to bottom, #f6d03f, #f8b90c)',
  transactionHistoryTabActiveBg:
    'transparent linear-gradient(180deg, #F6D03F 0%, #F8B90C 100%) 0% 0% no-repeat padding-box',
  transactionHistoryTabDefaultBg:
    'transparent linear-gradient(180deg, #596779 0%, #2D353F 100%) 0% 0% no-repeat padding-box',
  transactionHistoryGameHeaderBg:
    'transparent radial-gradient(closest-side at 50% 50%, #171B20 0%, #191B1E 100%) 0% 0% no-repeat padding-box',
  transactionHistoryGameHeaderBoxShadow: '0px 0px 17px #020722b3',
  transactionHistoryGameContentBoxShadow: '0px 0px 10px #1B1B1BB3',
  transactionHistoryGameContentBg:
    'transparent linear-gradient(180deg, #2D353F 0%, #192330 100%) 0% 0% no-repeat padding-box',
  transactionHistoryGameItemTitleBg: '#A7B0BD 0% 0% no-repeat padding-box',
  transactionHistoryGameItemTitleBoxShadow: '0px 3px 6px #00000029',
  transactionHistoryGameItemValueDebitBg: '#ff4b4b',
  transactionHistoryGameItemValueDebitBorder: '#FF4B4B',
  transactionHistoryGameItemValueCreditBg: '#00ff47',
  transactionHistoryGameItemValueCreditBorder: '#4CEF33',
  //myprofile

  myProfileItemCardsBg:
    'transparent linear-gradient(141deg, #3A434F 0%, #243343 100%) 0% 0% no-repeat padding-box',
  myProfileItemCardsBoxShadow: '3px 0px 12px #000000',
  myProfileItemCardsBorder: '#596779',
  myProfileYourBalanceBg:
    'transparent linear-gradient(141deg, #3A434F 0%, #243343 100%) 0% 0% no-repeat padding-box',
  myProfileYourBalanceBoxShadow: '3px 0px 12px #000000',
  myProfileYourBalanceBorder: '#596779',
  myProfileWithdrawBtnBg:
    'linear-gradient(rgb(246, 208, 63) 0%, rgb(248, 185, 12) 100%) 0% 0% no-repeat padding-box padding-box transparent',
  myProfileAllTransactionsBtnBg: '#11171d',
  myProfileAllTransactionsBtnBorder: '#ffc400',
  myProfileTransactionsHeaderBg: '#192330 0% 0% no-repeat padding-box',
  //dailyrewards
  dailyRewardsActiveItemBg:
    'transparent radial-gradient(closest-side at 50% 50%, #FFC400 0%, #FF6F00 100%) 0% 0% no-repeat padding-box',
  dailRewardsActiveItemBorder: '#FFDD00',
  dailyRewardsDefaultItemBg:
    'transparent radial-gradient(closest-side at 50% 50%, #85B1CB 0%, #5296BD 30%, #2A5B77 100%) 0% 0% no-repeat padding-box',
  dailRewardsDefaultItemBorder: '#0089D8',
  dailyRewardsCoinsBg: '#11171d',
  dailyRewardsChestWrapperBg: '#333d49',
  dailyRewardsChestWrapperBorder: '#4d5968',
  dailyRewardsGameInfoContainerBg:
    'transparent radial-gradient(closest-side at 50% 50%, #404F61 0%, #2B3746 100%) 0% 0% no-repeat padding-box',
  dailyRewardsGameInfoContainerBorder: '#596779',
  dailyRewardsGameInfoContainerBoxShadow: '0px -2px 23px #020722B3',
  dailyRewardsGamePlayContainerBg:
    'transparent radial-gradient(closest-side at 50% 50%, #2D353F 0%, #192330 100%) 0% 0% no-repeat padding-box',
  dailyRewardsGamePlayContainerBoxShadow: '0px 0px 17px #020722B3',
  dailyRewardsMileStoneProgressBg: '#0C1014 0% 0% no-repeat padding-box',
  dailyRewardsMileStoneProgressedAreaBg: '#FFC400 0% 0% no-repeat padding-box',
  dailyRewardsChestProgressedAreaBg: '#FFCF00 0% 0% no-repeat padding-box',
  dailyRewardsChestProgressedAreaBoxShadow: 'inset 0px 3px 6px #F7FF00',
  dailyRewardsChestProgressBg: '#63C6FF 0% 0% no-repeat padding-box',
  dailyRewardsGameInfoContainerBgMobile:
    'transparent linear-gradient(109deg, #3A434F 0%, #243343 100%) 0% 0% no-repeat padding-box',
  dailyRewardsGameInfoContainerBoxShadowMobile: '3px 0px 12px #000000',
  ///selectAvatar

  selectAvatarSelectedButtonBg:
    'transparent linear-gradient(180deg, #C5F63F 0%, #31C504 100%) 0% 0% no-repeat padding-box',
  selectAvatarSelectedButtonBoxShadow: 'inset 0px 2px 15px #7FFF0063',
  selectAvatarSelectedButtonBorder: '#59FF31',

  selectAvatarFreeButtonBg:
    'transparent linear-gradient(180deg, #F6C53F 0%, #FFC300 100%) 0% 0% no-repeat padding-box',
  selectAvatarFreeButtonBoxShadow: 'inset 0px 2px 15px #F6FF0063',
  selectAvatarFreeButtonBorder: '#FFF079'
};
